/* global $ */
'use strict';

function PhotoEdit(EVENTS, MODALS) {
	require('cropit');
	window.NIKE.returnedImage = false;
	var login = require('./login.js');
	var Hammer = require('hammerjs');
	var inkjet = require('inkjet');
	var page = require('page');
	var PubSub = require('pubsub-js');
	var imageEditorTool = {
		init: function () {
			this.apiPath = '//sag.nikecloud.com/rest/v1/imageS3';
			this.requestTimeout = 30000;
			this.classes = {
				reupload: 'reupload',
				loaderEnabled: 'loading-box--enabled',
				hidden: 'hidden',
				buttonDisabled: 'sag-button--disabled'
			};
			this.selectors = {
				wrapper: '.cropit-editor',
				input: '.image-input',
				preview: '.cropit-image-preview',
				upload: '.cropit-upload',
				loader: '.loading-box',
				changePhoto: '.change-photo',
				uploadIcon: '.cropit-upload-icon',
				currentFrame: '.slick-current .frame'
			};
			this.scale = 0;
			this.SIZE_LIMIT = 900;
			this.FRAME_SIZE = 900;
			this.WEIGHT_LIMIT = 5242880;
			this.IMAGE_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];

			this.$wrapper = $(this.selectors.wrapper);
			this.$loader = $(this.selectors.loader);

			this.$page = $('#opened');
			this.$buttonNext = $('.next-button', this.$page);

			PubSub.subscribe(EVENTS.IMAGE_SEND, this.apiRequest.bind(this));

			if (this.$wrapper.length) {
				this.$uploadIcon = $(this.selectors.uploadIcon, this.$wrapper);
				this.$uploadInput = $(this.selectors.input, this.$wrapper);
				this.$uploadButton = $(this.selectors.upload, this.$wrapper);
				this.hammerObject = new Hammer.Manager($(this.selectors.preview, this.$wrapper)[0]);
				this.hammerObject.add(new Hammer.Pinch());

				this.$wrapper.cropit({
					initialZoom: this.scale,
					smallImage: 'allow',
					onImageLoading: this.onImageLoading.bind(this),
					onImageLoaded: this.onImageLoaded.bind(this),
					onImageError: this.onImageError.bind(this),
					onFileReaderError: this.onImageError.bind(this)
				});

				this.attachHandlers();
			}
		},

		attachHandlers: function () {
			this.hammerObject.on('pinchstart pinchmove', function (e) {
				if (e.type === 'pinchstart') {
					this.scale = this.$wrapper.cropit('zoom') || 0;
				}
				this.$wrapper.cropit('zoom', this.scale * e.scale);
			}.bind(this));

			this.$uploadButton.on('click', function () {
				this.$uploadInput.click();
			}.bind(this));

			this.$uploadInput.on('change', function (e) {
				this.uploadImage(e);
			}.bind(this));

			PubSub.subscribe('cropSize', function (msg, data) {
				this.$wrapper.cropit('previewSize', {width: data.width, height: data.height});
				$(this.selectors.preview).css({top: data.top, left: data.left});
			}.bind(this));

			PubSub.subscribe(EVENTS.LOGIN_LOADED, function () {
				this.$loader.removeClass(this.classes.loaderEnabled);
				page(window.NIKE.urlId + '/login');
			}.bind(this));
		},

		uploadImage: function (event) {
			var deferred = new $.Deferred(),
				deferred2 = new $.Deferred(),
				imgInfo = {},
				imgAngle = 0,
				binary;


			if (event.target.files && event.target.files[0]) {
				this.onImageLoading();

				if (!this.checkImageWeight(event.target.files[0].size)) {
					return;
				}
				if (!this.checkImageType(event.target.files[0].type)) {
					return;
				}

				var reader = new FileReader();
				reader.onload = function (event) {
					try {
						binary = this.dataUrlToBinary(event.target.result, 65568);
						inkjet.exif(binary, function (err, tags) {
							if (tags && tags.Orientation) {
								switch (tags.Orientation.value) {
									case 3:
										imgAngle = -180;
										break;
									case 6:
										imgAngle = 90;
										break;
									case 8:
										imgAngle = -90;
										break;
								}
							}
							imgInfo.dataUrl = event.target.result;
							imgInfo.angle = imgAngle;

							deferred.resolve(imgInfo);
						});
					} catch (error) {
						PubSub.publish(EVENTS.MODAL_CLOSE);
						PubSub.publish(EVENTS.MODAL_OPEN, MODALS.ERROR_PROCESS);
					}
				}.bind(this);

				reader.readAsDataURL(event.target.files[0]);
			}

			deferred.done(function (imgInfo) {
				var canvas = document.createElement('canvas'),
					ctx = canvas.getContext('2d'),
					image = new Image(),
					imgPositionLeft = 0,
					imgPositionTop = 0;

				image.src = imgInfo.dataUrl;
				image.onload = function (event) {
					if (imgInfo.angle === 0) {
						deferred2.resolve(imgInfo);
						return;
					}

					if (Math.abs(imgInfo.angle) === 90) {
						canvas.height = event.target.width;
						canvas.width = event.target.height;
					} else {
						canvas.height = event.target.height;
						canvas.width = event.target.width;
					}

					switch (imgInfo.angle) {
						case 90:
							imgPositionTop = -event.target.height;
							break;
						case -90:
							imgPositionLeft = -event.target.width;
							break;
						case -180:
							imgPositionLeft = -event.target.width;
							imgPositionTop = -event.target.height;
							break;
					}

					ctx.rotate(imgInfo.angle * Math.PI / 180);
					ctx.drawImage(event.target, imgPositionLeft, imgPositionTop);

					imgInfo.dataUrl = canvas.toDataURL();
					deferred2.resolve(imgInfo);
				}.bind(this);
			}.bind(this));

			deferred2.done(function (imgInfo) {
				this.$wrapper.cropit('imageSrc', imgInfo.dataUrl);
			}.bind(this));
		},

		dataUrlToBinary: function (t, e) {
			var i, n, r, o, s, a, c, h, l, u;
			for (i = ';base64,', c = t.split(i), n = c[1], e > 0 && (u = 4 * Math.ceil(4 * e / 3 / 4), n = n.substr(0, u)), h = window.atob(n), a = h.length, r = new Uint8Array(a), o = s = 0, l = a; l >= 0 ? l >= s : s >= l; o = l >= 0 ? ++s : --s) {
				r[o] = h.charCodeAt(o);
			}
			return r;
		},

		exportBase64: function () {
			return this.$wrapper.cropit('export', {
				type: 'image/jpeg',
				quality: 0.9
			});
		},

		getCroppedImageSize: function () {
			return this.$wrapper.cropit('imageSize');
		},

		checkImageWeight: function (imageWeight) {
			if (imageWeight > this.WEIGHT_LIMIT) {
				this.declineImage(MODALS.ERROR_WEIGHT);
				return false;
			} else {
				return true;
			}
		},

		checkImageType: function (imageType) {
			if (this.IMAGE_TYPES.indexOf(imageType) === -1) {
				this.declineImage(MODALS.ERROR_TYPE);
				return false;
			} else {
				return true;
			}
		},

		onImageLoading: function () {
			//fix for iOS the same image loading 2nd time
			//this.$loader.addClass(this.classes.loaderEnabled);
		},

		onImageLoaded: function () {
			this.$loader.removeClass(this.classes.loaderEnabled);
			this.$uploadIcon.addClass(this.classes.hidden);

			if (!this.$uploadButton.hasClass(this.classes.reupload)) {
				this.$uploadButton.addClass(this.classes.reupload);
			}

			$(this.selectors.changePhoto).fadeIn().off().on('click', function () {
				this.$uploadInput.val('');
				$(this.selectors.input, this.$wrapper).click();
			}.bind(this));

			//set max x2 zoom from border
			var setZoom;
			if (this.$wrapper.cropit('imageSize').height >= this.$wrapper.cropit('imageSize').width) {
				setZoom = this.SIZE_LIMIT / this.$wrapper.cropit('imageSize').width;
				this.$wrapper.cropit('maxZoom', setZoom);
			} else {
				setZoom = this.SIZE_LIMIT / this.$wrapper.cropit('imageSize').height;
				this.$wrapper.cropit('maxZoom', setZoom);
			}

			this.$buttonNext
				.removeClass(this.classes.buttonDisabled)
				.off('click')
				.on('click', function (e) {
					e.preventDefault();
					if (this.$buttonNext.hasClass(this.classes.buttonDisabled)) {
						return;
					}
					this.$loader.addClass(this.classes.loaderEnabled);
					this.slickSelected = window.location.hash;
					if (!window.NIKE.isLoggedIn) {
						login(EVENTS, MODALS);
					} else {
						PubSub.publish(EVENTS.IMAGE_SEND, window.NIKE.token);
					}
				}.bind(this));
		},

		onImageError: function (data) {
			this.declineImage(MODALS.ERROR_SIZE);
			this.$loader.removeClass(this.classes.loaderEnabled);
		},

		declineImage: function (type) {
			this.$uploadInput.val('');
			this.$loader.removeClass(this.classes.loaderEnabled);
			PubSub.publish(EVENTS.MODAL_CLOSE);
			PubSub.publish(EVENTS.MODAL_OPEN, type);
		},

		apiRequest: function (msg, accessToken) {
			this.$loader.addClass(this.classes.loaderEnabled);

			var urlParts = window.location.href.split('/'),
				part = urlParts[3] !== 'index.html' && urlParts[3] !== '#!' ? '/' + urlParts[3] : '',
				$currentFrame = this.$page.find(this.selectors.currentFrame),
				data = {
					image: this.exportBase64(),
					treatment: urlParts[0] + '//' + urlParts[2] + part + '/' + $currentFrame.attr('data-pngs'),
					tWidth: this.FRAME_SIZE,
					tHeight: this.FRAME_SIZE,
					topLeftX: $currentFrame.attr('data-left'),
					topLeftY: $currentFrame.attr('data-top'),
					sizeX: $currentFrame.attr('data-width'),
					sizeY: $currentFrame.attr('data-height')
				};

			$.ajax({
				type: 'POST',
				url: this.apiPath + '?access_token=' + accessToken,
				contentType: 'application/json',
				dataType: 'text',
				headers: {'Access-Control-Request-Method': 'POST'},
				data: JSON.stringify(data),
				beforeSend: this.apiBeforeSendHandler.bind(this),
				complete: this.apiCompleteHandler.bind(this),
				success: this.apiSuccessHandler.bind(this),
				error: this.apiErrorHandler.bind(this)
			});
		},

		apiBeforeSendHandler: function () {
			this.requestTimeoutInstance = setTimeout(function () {
				PubSub.publish(EVENTS.MODAL_CLOSE);
				PubSub.publish(EVENTS.MODAL_OPEN, MODALS.ERROR_TIMEOUT);
			}.bind(this), this.requestTimeout);
		},

		apiCompleteHandler: function () {
			if (this.requestTimeoutInstance) {
				clearInterval(this.requestTimeoutInstance);
				this.requestTimeoutInstance = null;
			}
		},

		apiSuccessHandler: function (data) {
			window.NIKE.returnedImage = true;
			var img = $('<img src="' + data + '" />');
			$('#share .img-sharing').html(img);
			img.load(function () {
				this.$loader.removeClass(this.classes.loaderEnabled);
				page(window.NIKE.urlId + '/share');
			}.bind(this));
		},

		apiErrorHandler: function (data) {
			PubSub.publish(EVENTS.MODAL_CLOSE);
			PubSub.publish(EVENTS.MODAL_OPEN, MODALS.ERROR_PROCESS);
			page(this.slickSelected);
			this.$loader.removeClass(this.classes.loaderEnabled);
		}
	};

	imageEditorTool.init();

}

module.exports = PhotoEdit;
